import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themeFour/history.png'


const _hoisted_1 = { class: "saque_card" }
const _hoisted_2 = { class: "top_bar" }
const _hoisted_3 = { class: "left_section" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "content_text" }

import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { navToBack } from '@/view/components/supportFunction'


export default /*@__PURE__*/_defineComponent({
  __name: 'topHeaderCard',
  props: {
  isPopupCloseBackIcon: {
    type: Boolean,
    default: true
  },
  text: {
        type: String,
        default: () => ''
    },
   subText: {
        type: String,
        default: () => ''
    }, 
   hideBacKIcon:{
        type: Boolean,
        default: () => false,
        required: false
    } 
},
  emits: ['closePopup', 'goToFund'],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const userStore = useUserStore()

const emits = __emit

const props = __props

const handleBackClick = () => {
  navToBack(router, props.isPopupCloseBackIcon, emits)
  userStore.setRechargeBonusType(0)
}

const handleFundClick = () => {
  emits('goToFund')
}

const goToSupport = () => {
  router.push('/sd-message')
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(props.text), 1),
        _createElementVNode("div", {
          class: "fund_icon",
          onClick: handleFundClick
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            style: {"width":"15px"}
          }, null, -1)
        ]))
      ]),
      (!__props.hideBacKIcon)
        ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 0,
            name: "cross",
            size: "22",
            class: "close_icon",
            onClick: handleBackClick
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(props.subText), 1),
    _createElementVNode("div", {
      class: "support_link",
      onClick: goToSupport
    }, [
      _createVNode(_component_van_icon, {
        name: "service-o",
        size: "16"
      }),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.support')), 1)
    ])
  ]))
}
}

})